import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FieldBase } from "../../../forms/models/FieldBase";
import { Document } from "../../models/document";
import { IDocumentGalleryFieldParams } from "./models/idocument-gallery-field-params";

@Component({
	selector: "calao-document-gallery-field",
	templateUrl: "./document-gallery-field.component.html",
	styleUrls: ["./document-gallery-field.component.scss"],
	standalone: false
})
export class DocumentGalleryFieldComponent extends FieldBase<{}, any, IDocumentGalleryFieldParams> implements OnInit {
	//#region PROPERTIES

	public params?: IDocumentGalleryFieldParams;

	//#endregion PROPERTIES

	//#region METHODS

	constructor(poChangeDetectorRef: ChangeDetectorRef) {
		super(poChangeDetectorRef);
	}

	public override ngOnInit(): void {
		super.ngOnInit();
		this.params = this.props;
	}

	public onDocumentsChanged(paDocuments: Document[]): void {
		this.observableFieldValue.value = paDocuments;
	}

	//#endregion METHODS
}
